import { Injectable } from '@angular/core';

import {httpOptions} from '../../configurations/configuration';
import { HttpClient, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {


    constructor(private http: HttpClient) { }

    updateSubscription(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.updateSubscriptionUrl, postObj,httpOptions);
    }
          
    insertSubscription(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertSubscriptionUrl, postObj,httpOptions);
    }    
    
    getSubscription( id: any) : Observable<any> {
        
        if(id){
  
        }
        else {
            id = 1;
        }
  
        return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getSubscriptionUrl+"/" + id);
    }
  
    getAllSubscription(filterObj,start,limit){

        filterObj.languageId = localStorage.getItem('languageId');

        let urlGetAllAsset = environment.apiURL + environment.adminApiUrl + environment.getSubscriptionUrl +'?filter='+encodeURIComponent(JSON.stringify(filterObj))+'&start='+start+'&limit='+limit;
        return this.http.get<any>(urlGetAllAsset)
    }
  
    deleteSubscription(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.deleteSubscriptionUrl, postObj,httpOptions);
    }
}
